import { render, staticRenderFns } from "./dialogue-detail.vue?vue&type=template&id=10d69c0d"
import script from "./dialogue-detail.vue?vue&type=script&lang=js"
export * from "./dialogue-detail.vue?vue&type=script&lang=js"
import style0 from "./dialogue-detail.vue?vue&type=style&index=0&id=10d69c0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports